module.exports = __webpack_public_path__ + "static/media/hourglass-half.609bb8dd.svg";